import { Services } from '@sigma-frontend-libs/commons'

import { components, labelModes, services } from '@/utils'

import contactsTag from '@/components/services/contacts/tag'
import redirectButton from '@/components/services/sendingsCreate/redirectButton'

function renderRecipientTypeSelect(h, type) {
  const proxyKeys = Object.keys(this.proxy)

  return h(
    components.select,
    {
      props: {
        value: this.proxy[type],
        itemsDisabled: this.proxy[proxyKeys[Math.abs(proxyKeys.indexOf(type) - 1)]],
        label: this.getTranslate(`${services.sendings}.labels.targets.${type}`),
        hint: this.getTranslate(`${services.sendings}.labels.targets.info`),
        error: this.error,
        service: services.contactLists,
        labelMode: labelModes.hidden,
        pasteFilter: this.pasteFilter,
        paste: true,
        combobox: true,
        multiple: true,
        setOnBlur: true,
        autocomplete: true,
        // NOTE: 188 код на кнопке с буквой Б
        // 32 код убран по задаче 1443
        freeInputTriggers: [ 9, 13, /* 32, 188, */194 ]
      },
      on: {
        input: event => {
          this.proxy[type] = this.checkValues(event)
        }
      },
      scopedSlots: {
        selection: ({ item, removeByValue }) => {
          return h(
            contactsTag,
            {
              props: {
                label: item.title,
                ListId: item.id,
                cancel: () => {
                  return removeByValue(item.id)
                }
              },
              key: item.id
            }
          )
        }
      }
    }
  )
}
function renderRedirectButton(h) {
  return h(
    redirectButton,
    {
      props: {
        service: Services.contacts
      }
    }
  )
}
function renderRecipientField(h, type) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__recipients-recipient`
    },
    [
      renderRecipientTypeSelect.call(this, h, type),
      renderRedirectButton.call(this, h)
    ]
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__recipients`
    },
    [
      renderRecipientField.call(this, h, 'include'),
      renderRecipientField.call(this, h, 'exclude')
    ]
  )
}
